import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveExternalTeachers = createAsyncThunk<ExternalTeacherVM[], void, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/externalTeachers/retrieve",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.listExternalTeachers();
  },
);
